import React from "react";
import { useWindowSize } from 'react-use';
import Confetti from 'react-confetti';
import { Container, Grid, Paper, Typography, Button } from '@mui/material';
import globals from "../globals";
import zIndex from "@mui/material/styles/zIndex";

const Successful = () => {
    const { width, height } = useWindowSize();

    return (
        <Container sx={{mt:5}}>
            <Grid container justifyContent={'center'} textAlign={'center'} direction={'column'} alignContent={'center'} spacing={4}>
                <Grid item>
                    <a href='/'><img src='eacademiabg-logo.webp' width={200} height={90} href='/'/></a>
                </Grid>
                <Confetti width={width} height={height}/>
                <Grid item>
                    <Paper elevation={4} sx={{ width: '80vh', borderRadius: 5 }}>
                        <Grid container justifyContent={'center'} textAlign={'center'} direction={'column'}>
                            <Grid item>
                                <img src="success.webp" width={250} height={250} />
                            </Grid>
                            <Grid item>
                                {/* <Typography sx={{ color: globals.colors.lightRed, fontSize: 30, fontWeight: 'bold' }}>{props.location.state.title}</Typography> */}
                                <Typography sx={{ color: globals.colors.lightRed, fontSize: 30, fontWeight: 'bold' }}>Успешно плащане!</Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 15, fontWeight: 'bold' }}>Благодарим ти, че избра онлайн уроци от eAcademiaBg!</Typography>
                            </Grid>
                            <Grid item>
                                <Button variant='contained' href='/dashboard' type='submit' size='large' sx={{
                                    mt: 3, mb:3, px: 5, backgroundColor: globals.colors.lightRed, '&:hover': {
                                        backgroundColor: globals.colors.darkRed,
                                    }, textTransform:'none', fontWeight:'bold'
                                }}> Към моя профил</Button>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    );
}

export default Successful